const nextRoutes = require('next-routes');

const routes = nextRoutes();
routes
  .add('index', '/')
  .add('sellnow', '/sellnow/')
  .add('us/item', '/us/item/:id/')
  .add('us/seller-tools/predictions', '/us/seller-tools/predictions/')
  .add('u', '/u/:userId/')
  .add('mypage/sales', '/mypage/sales')
  .add('mypage/profile', '/mypage/profile')
  .add('us/category', '/us/category/:categoryId?/')
  .add('us/brand', '/us/brand/:brandId?/:categoryId?/')
  .add('us/order-status/shipping', '/us/order-status/shipping/:itemId/')
  .add('favorites', '/favorites/')
  .add('mypage/listings/active', '/mypage/listings/active/')
  .add('mypage/listings/inactive', '/mypage/listings/inactive/')
  .add('mypage/listings/in_progress', '/mypage/listings/in_progress/')
  .add('mypage/listings/complete', '/mypage/listings/complete/')
  .add(
    'mypage/listings/draft/action-required',
    '/mypage/listings/draft/action-required/',
  )
  .add(
    'mypage/listings/draft/ready-to-list',
    '/mypage/listings/draft/ready-to-list/',
  )
  .add('acl', '/acl/')
  .add('idVerification', '/id_verification/')
  .add('search', '/search/')
  .add('transaction/_email', '/transaction/_email/:itemId/')
  .add('transaction/address', '/transaction/address/:itemId/')
  .add('transaction/buy', '/transaction/buy/:itemId/')
  .add('transaction/offer', '/transaction/offer/:itemId')
  .add('transaction/confirmation', '/transaction/confirmation/')
  .add('transaction/select_payment', '/transaction/select_payment/:itemId/')
  .add('transaction/card', '/transaction/card/:itemId/')
  .add(
    'transaction/card_verification',
    '/transaction/card_verification/:itemId/',
  )
  .add('express-checkout', '/express-checkout/:itemId/')
  .add('express-checkout-confirmation', '/express-checkout-confirmation')
  .add('notification-settings', '/notification-settings')
  .add('browse', '/browse')
  .add('fall-fashion', '/fall-fashion/')
  .add('us/gift-guide', '/us/gift-guide/')
  .add('us/deals', '/us/deals/')
  .add('halloween', '/halloween/')
  .add('us/winter-fashion', '/us/winter-fashion/')
  .add('shipping', '/shipping/')
  .add('shipping/pack_and_ship', '/shipping/pack_and_ship/:sub*')
  .add('us/shop', '/us/shop/:keyword/')
  .add('us/shop/list', '/us/shop')
  .add('us/cart', '/us/cart/')
  .add('explore', '/explore/')
  .add('import-listings', '/import-listings/:categoryId/:brandId')
  .add('sell', '/sell/', 'sell')
  .add('sell-yours', '/sell/yours/:itemId/', 'sell')
  .add('edit', '/sell/edit/:itemId/', 'sell')
  .add('sell/import', '/sell/import/')
  .add('sell/import/history', '/sell/import/history/')
  .add('relist', '/sell/relist/:itemId/', 'sell')
  .add('draft', '/sell/draft/:draftItemId/', 'sell')
  .add('getting-paid', '/getting-paid/')
  .add('us/how-to-sell', '/us/how-to-sell/')
  .add('iphone-sell', '/iphone-sell/')
  .add('us/funko', '/us/funko/')
  .add('us/authenticate', '/us/authenticate/')
  .add('us/firstlisting', '/us/firstlisting/')
  .add('us/buying-tips', '/us/buying-tips/')
  .add('selling-guide/selling-tips', '/selling-guide/selling-tips/')
  .add('selling-guide/selling-on-mercari', '/selling-guide/selling-on-mercari/')
  .add('selling-guide/selling-guide', '/selling-guide/selling-guide/')
  .add('selling-guide/pricing-101', '/selling-guide/pricing-101/')
  .add('selling-guide/photo-guide', '/selling-guide/photo-guide/')
  .add('us/become-a-pro-seller', '/us/become-a-pro-seller/')
  .add('us/pro-seller/signup', '/us/pro-seller/signup/')
  .add('us/TheTalk', '/us/TheTalk/')
  // v1 routes
  // TODO: align v1 routes with v2
  .add('v1_category_index', '/us/category/', 'category')
  .add('v1_brand_index', '/us/brand/', 'us/brand')
  .add(
    'promotions_electronics',
    '/promotions/electronics/',
    'promotions/electronics',
  )
  .add('promotions_browse', '/promotions/browse/', 'promotions/browse')
  .add('us/digital/how-it-works', '/us/digital/how-it-works/')
  .add('us/digital/order_status', '/us/digital/order_status/:id/')
  .add('us/digital/index', '/us/digital/')
  .add('us/digital/dec-promotion', '/us/digital/dec-promotion/')
  .add('us/digital/sku', '/us/digital/sku/:id/')
  .add('us/digital/item', '/us/digital/item/:id/')
  .add('us/digital/search', '/us/digital/search/')
  .add('us/digital/u', '/us/digital/u/:userId/')
  .add('us/digital/transaction/buy', '/us/digital/transaction/buy/:itemId/')
  .add(
    'us/digital/transaction/select_payment',
    '/us/digital/transaction/select_payment/:itemId/',
  )
  .add(
    'us/digital/transaction/address',
    '/us/digital/transaction/address/:itemId/',
  )
  .add(
    'us/digital/gg_terms_and_conditions',
    '/us/digital/gg_terms_and_conditions/',
  )
  .add('us/digital/gg_discounts', '/us/digital/gg_discounts/')
  .add('us/digital/transaction/card', '/us/digital/transaction/card/:itemId/')
  .add(
    'us/digital/transaction/card_verification',
    '/us/digital/transaction/card_verification/:itemId/',
  )
  .add(
    'us/digital/transaction/confirmation',
    '/us/digital/transaction/confirmation/',
  )
  .add('us/digital/sell', '/us/digital/sell/')
  .add(
    'us_digital_sell_edit',
    '/us/digital/sell/edit/:itemId/',
    'us/digital/sell',
  )
  .add('v1_search', '/search/', 'search')
  .add('email-confirmation/done', '/email_confirmation/done/')
  .add('mypage/chat', '/mypage/chat/:filter?/:topicId?')
  .add('/us/featured/:fp_id/', '/featured')
  .add('us/reports/sales', '/us/reports/sales')
  .add('/us/lp/selling-on-mercari/:lp_id/', '/us/selling-lp')
  .add('invitations', '/invitations/')
  .add('/us/now', '/us/now')
  .add('us/selling/dashboard', '/us/selling/dashboard')
  .add('us/personal_data', '/us/personal_data/:dataRequestId/');

module.exports = routes;
